import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import './i18n';
import { GlobalErrorBoundary } from "@/components/GlobalErrorBoundary";

// Suppress benign ResizeObserver loop errors (browser limitation, not an app bug)
const _origError = window.onerror;
window.onerror = function (msg, source, lineno, colno, error) {
  if (typeof msg === 'string' && msg.includes('ResizeObserver loop')) return true;
  if (_origError) return _origError(msg, source, lineno, colno, error);
};
window.addEventListener('error', (e) => {
  if (e.message?.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
);

// Fade out the pre-mount boot splash once React has painted, then remove it.
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    const boot = document.getElementById("corvana-boot");
    if (!boot) return;
    boot.classList.add("corvana-boot-hide");
    setTimeout(() => boot.remove(), 500);
  });
});
